
import { Component, Prop, Vue } from "vue-property-decorator";
import VueQrcodeReader from "@/components/qrcode/scanners/VueQrcodeReader.vue";
import { regex } from "@/utils/formRules";
import { Getter } from "vuex-class";

const UNSUPPORTED_BROWSER_VERSIONS: RegExp[] = [
  /^Safari: 16.\w/,
  /^Safari: 17.4.1$/,
];

@Component({
  components: {
    VueQrcodeReader,
  },
})
export default class QrCodeScannerWrapper extends Vue {

  get errorTranslation() {
    return this.$i18n?.t(`alerts.error.qrCodeReader.${this.readerError}`);
  }

  get isPwaBrowserVersionError(): boolean {
    return UNSUPPORTED_BROWSER_VERSIONS.some((version) => version.test(this.browserVersion)) && this.isPwa;
  }

  get version(): string {
    return this.browserVersion.split(": ")[1];
  }

  @Prop({default: true})
  public hasForceInput: boolean;

  @Prop({default: false})
  public loading: boolean;

  @Prop({default: true})
  public displayReloadButton: boolean;

  @Getter private browserVersion: string;
  @Getter private isPwa: boolean;
  @Getter private isMobile: boolean;

  private qrCodeString: string = "";
  private readerError: any = null;
  private displayScanner: boolean = true;
  private isInputDisabled: boolean = false;

  public async reloadScanner(): Promise<void> {
    this.displayScanner = false;
    await this.clearInput();
    this.displayScanner = true;
  }

  private mounted(): void {
    this.$nextTick().then(this.focusUsbScanInput);
  }

  private focusUsbScanInput(): void {
    if (this.hasForceInput && !this.isMobile) {
      (this.$refs.fromUsbScanner as HTMLFormElement).focus();
    }
  }

  private onError(error: string): void {
    this.readerError = error;
  }

  private onDecode(decodedString: string): void {
    // Check token format
    const acceptedFormats = [
      regex.token,
      regex.masterlockQrCode,
      regex.imei,
    ];
    const isValidToken: boolean = acceptedFormats.some((format) => format.test(decodedString));
    if (isValidToken) {
      // If ok, send request
      this.$emit("decode", decodedString);
    } else {
      // Else, display error message
      this.readerError = "wrongTokenFormat";
    }
  }

  private forceReadQR(): void {
    this.qrCodeString = this.qrCodeString.replace(/§/g, "-");
    // Disable input to prevent user from scanning again
    this.isInputDisabled = true;
    this.onDecode(this.qrCodeString);
  }

  private async clearInput(): Promise<void> {
    this.readerError = null;
    this.qrCodeString = "";
    this.isInputDisabled = false;
    await this.$nextTick();
    this.focusUsbScanInput();
  }

  private enterKeyPress(e: KeyboardEvent): void {
    if (e.keyCode === 13) {
      this.forceReadQR();
    }
  }

  private copyMylobyLink(): void {
    navigator.clipboard.writeText("key.myloby.com");
  }
}
